// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PaymentMethods {
    flex-direction: column;
}

.PaymentMethods-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    padding-top: 100px;
    padding-bottom: 60px;
}

.PaymentMethods-Container {
    background: none !important;
}

.PaymentMethods-CountryList {
    background: #fff;
    padding: 70px 30px;
    border-radius: 32px;
    margin-right: 32px;
}

.PaymentMethods-types {
    background: #fff;
    border-radius: 32px;
    padding: 30px 85px;
}

.PaymentMethods-logo {
    padding-inline: 8px;
    padding-block: 6px;
    width: 85px;
    object-fit: contain;
    border-radius: 16px;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 8px;
    aspect-ratio: 2 / 1;
    height: 62px;
}

.PaymentMethods-Row {
    border-bottom: 1px solid rgb(241, 241, 241);
    padding-bottom: 32px;
    padding-top: 28px;
    min-height: 100px;
}

.PaymentMethods-Col {
    display: flex;
    justify-content: center;
}

  
.PaymentMethods-Header {
    margin-bottom: 24px;
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 0px 18px;
}

.PaymentMethods-Dropdown {
    width: 100%;
    height: 56px;
}

.PaymentMethods-type-name {
   text-transform: uppercase;
}

/* antd classes */
:where(.css-dev-only-do-not-override-142vneq).ant-menu-light .ant-menu-item-selected, :where(.css-dev-only-do-not-override-142vneq).ant-menu-light>.ant-menu .ant-menu-item-selected {
    background: none !important;
}

:where(.css-dev-only-do-not-override-142vneq).ant-menu-light:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):hover, :where(.css-dev-only-do-not-override-142vneq).ant-menu-light>.ant-menu:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):hover {
    background: none !important;
}

:where(.css-dev-only-do-not-override-142vneq).ant-layout {
    background: none !important;
}

.PaymentMethods-Dropdown .ant-select-selector {
    background-color: #f0f0f0 !important;
}

:where(.css-dev-only-do-not-override-142vneq).ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    padding: 14px 24px;
}

:where(.css-dev-only-do-not-override-142vneq).PaymentMethods-Dropdown.ant-select-single .ant-select-selector {
    font-size: 18px;
}

.ant-select .ant-select-outlined .PaymentMethods-Dropdown .bt-medium-500 .css-dev-only-do-not-override-142vneq .ant-select-focused .ant-select-single .ant-select-show-arrow .ant-select-open .ant-select-show-search {
    font-size: 18px;
}

.PaymentMethods-grid-container {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 32px;
}

@media (max-width: 1770px) {
    .PaymentMethods-grid-container {
        grid-template-columns: repeat(5, 1fr);
    }
}

@media (max-width: 1440px) {
    .PaymentMethods-grid-container {
        grid-template-columns: repeat(4, 1fr);
    }
}
@media (max-width: 1300px) {
    .PaymentMethods-grid-container {
        grid-template-columns: repeat(3, 1fr); 
        gap: 16px;
    }
}
@media (max-width: 1024px) {

    .PaymentMethods-logo {
        width: 80px;
    }
}

@media (max-width: 480px) {
    .PaymentMethods-grid-container {
        grid-template-columns: repeat(2, 1fr); 
    }
}

li.ant-menu-item.ant-menu-item-selected.ant-menu-item-only-child.b4-body-400:hover, li.ant-menu-item.ant-menu-item-active.ant-menu-item-only-child.b4-body-400:active {
    background: none !important;
}

.ant-menu-item.ant-menu-item-selected.ant-menu-item-only-child.b4-body-400, .ant-menu-item.ant-menu-item-active.ant-menu-item-only-child.b4-body-400 {
    background: none !important;
}

.ant-menu-item.ant-menu-item-selected.ant-menu-item-only-child.b4-body-400, .ant-menu-item.ant-menu-item-only-child.b4-body-400 {
    padding-left: 0 !important;
    margin: 0;
}

.PaymentMethodDetail-title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0px;
}

.PaymentMethodDetail-country {
    display: flex;
    flex-direction: row;
    justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/css/PaymentMethods.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,0CAA0C;IAC1C,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,2CAA2C;IAC3C,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;;AAGA;IACI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;GACG,yBAAyB;AAC5B;;AAEA,iBAAiB;AACjB;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;AACA;IACI;QACI,qCAAqC;QACrC,SAAS;IACb;AACJ;AACA;;IAEI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B","sourcesContent":[".PaymentMethods {\n    flex-direction: column;\n}\n\n.PaymentMethods-title {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    align-self: stretch;\n    padding-top: 100px;\n    padding-bottom: 60px;\n}\n\n.PaymentMethods-Container {\n    background: none !important;\n}\n\n.PaymentMethods-CountryList {\n    background: #fff;\n    padding: 70px 30px;\n    border-radius: 32px;\n    margin-right: 32px;\n}\n\n.PaymentMethods-types {\n    background: #fff;\n    border-radius: 32px;\n    padding: 30px 85px;\n}\n\n.PaymentMethods-logo {\n    padding-inline: 8px;\n    padding-block: 6px;\n    width: 85px;\n    object-fit: contain;\n    border-radius: 16px;\n    box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 8px;\n    aspect-ratio: 2 / 1;\n    height: 62px;\n}\n\n.PaymentMethods-Row {\n    border-bottom: 1px solid rgb(241, 241, 241);\n    padding-bottom: 32px;\n    padding-top: 28px;\n    min-height: 100px;\n}\n\n.PaymentMethods-Col {\n    display: flex;\n    justify-content: center;\n}\n\n  \n.PaymentMethods-Header {\n    margin-bottom: 24px;\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    padding: 0px 18px;\n}\n\n.PaymentMethods-Dropdown {\n    width: 100%;\n    height: 56px;\n}\n\n.PaymentMethods-type-name {\n   text-transform: uppercase;\n}\n\n/* antd classes */\n:where(.css-dev-only-do-not-override-142vneq).ant-menu-light .ant-menu-item-selected, :where(.css-dev-only-do-not-override-142vneq).ant-menu-light>.ant-menu .ant-menu-item-selected {\n    background: none !important;\n}\n\n:where(.css-dev-only-do-not-override-142vneq).ant-menu-light:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):hover, :where(.css-dev-only-do-not-override-142vneq).ant-menu-light>.ant-menu:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):hover {\n    background: none !important;\n}\n\n:where(.css-dev-only-do-not-override-142vneq).ant-layout {\n    background: none !important;\n}\n\n.PaymentMethods-Dropdown .ant-select-selector {\n    background-color: #f0f0f0 !important;\n}\n\n:where(.css-dev-only-do-not-override-142vneq).ant-select-single:not(.ant-select-customize-input) .ant-select-selector {\n    padding: 14px 24px;\n}\n\n:where(.css-dev-only-do-not-override-142vneq).PaymentMethods-Dropdown.ant-select-single .ant-select-selector {\n    font-size: 18px;\n}\n\n.ant-select .ant-select-outlined .PaymentMethods-Dropdown .bt-medium-500 .css-dev-only-do-not-override-142vneq .ant-select-focused .ant-select-single .ant-select-show-arrow .ant-select-open .ant-select-show-search {\n    font-size: 18px;\n}\n\n.PaymentMethods-grid-container {\n    display: grid;\n    grid-template-columns: repeat(6, 1fr);\n    gap: 32px;\n}\n\n@media (max-width: 1770px) {\n    .PaymentMethods-grid-container {\n        grid-template-columns: repeat(5, 1fr);\n    }\n}\n\n@media (max-width: 1440px) {\n    .PaymentMethods-grid-container {\n        grid-template-columns: repeat(4, 1fr);\n    }\n}\n@media (max-width: 1300px) {\n    .PaymentMethods-grid-container {\n        grid-template-columns: repeat(3, 1fr); \n        gap: 16px;\n    }\n}\n@media (max-width: 1024px) {\n\n    .PaymentMethods-logo {\n        width: 80px;\n    }\n}\n\n@media (max-width: 480px) {\n    .PaymentMethods-grid-container {\n        grid-template-columns: repeat(2, 1fr); \n    }\n}\n\nli.ant-menu-item.ant-menu-item-selected.ant-menu-item-only-child.b4-body-400:hover, li.ant-menu-item.ant-menu-item-active.ant-menu-item-only-child.b4-body-400:active {\n    background: none !important;\n}\n\n.ant-menu-item.ant-menu-item-selected.ant-menu-item-only-child.b4-body-400, .ant-menu-item.ant-menu-item-active.ant-menu-item-only-child.b4-body-400 {\n    background: none !important;\n}\n\n.ant-menu-item.ant-menu-item-selected.ant-menu-item-only-child.b4-body-400, .ant-menu-item.ant-menu-item-only-child.b4-body-400 {\n    padding-left: 0 !important;\n    margin: 0;\n}\n\n.PaymentMethodDetail-title {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px 0px;\n}\n\n.PaymentMethodDetail-country {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
